import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  info: JSON.parse(localStorage.getItem("userInfo")),
  error: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.info = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
